import { parseTime } from './ruoyi.js'

/**
 * 统一用户界面中的日期时间显示，兼容后端 LocalDateTime 的 ISO `T` 格式。
 * 无时区的时间按原值展示，避免把业务时间意外转换时区。
 */
export function displayDateTime(value, fallback = '-') {
  if (value == null || value === '') return fallback
  let normalized = value

  if (typeof value === 'string') {
    const text = value.trim()
    if (!text) return fallback
    const localDateTime = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})(?::(\d{2}))?(?:\.\d+)?$/.exec(text)
    if (localDateTime) return `${localDateTime[1]} ${localDateTime[2]}:${localDateTime[3] || '00'}`
    if (!/^\d+$/.test(text)) {
      const parsed = new Date(text)
      if (Number.isNaN(parsed.getTime())) return fallback
      normalized = parsed
    }
  }

  const formatted = parseTime(normalized, '{y}-{m}-{d} {h}:{i}:{s}')
  return formatted && !formatted.includes('NaN') ? formatted : fallback
}
